import React, { useState } from 'react';
import { IconButton, TextField, Typography, Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';

function secondsToMinutes(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
}

function minutesToSeconds(time) {
    const [minutes, seconds] = time.split(':').map(Number);
    return minutes * 60 + seconds;
}

function Timestamp({ timestamp, index, lineTimestamps, type, setLineTimestamps, setTextFiledIsActive }) {
    const [time, setTime] = useState(secondsToMinutes(timestamp));
    const [isEditing, setIsEditing] = useState(false);

    function handleTimeChange(e) {
        setTime(e.target.value);
    }

    function onEdit() {
        const line = lineTimestamps[index];
        line[type] = minutesToSeconds(time);
        setLineTimestamps({
            ...lineTimestamps,
            [index]: line,
        });
        setIsEditing(false);
        setTextFiledIsActive(false);
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '5px',
                cursor: 'pointer',
                backgroundColor: isEditing ? 'background.paper' : '',
            }}
            onClick={
                !isEditing
                    ? () => {
                        setIsEditing(true);
                        setTextFiledIsActive(true);
                    }
                    : () => { }
            }
        >
            {!isEditing ? (
                <Typography sx={{ fontSize: '10px' }} color="textSecondary">
                    {secondsToMinutes(timestamp)}
                </Typography>
            ) : (
                <TextField
                    variant="outlined"
                    value={time}
                    onChange={handleTimeChange}
                    sx={{
                        width: '6rem',
                        mr: 1,
                        '& input': {
                            padding: '2px 4px',
                            fontSize: '10px',
                            borderRadius: '4px'
                        }
                    }}
                />
            )}
            <IconButton
                // size="10px"
                color="primary"
                onClick={isEditing ? onEdit : () => setIsEditing(true)}
            >
                {isEditing ? <CheckIcon sx={{ fontSize: '15px' }} /> : <EditIcon sx={{ fontSize: '15px' }} />}
            </IconButton>
        </Box>
    );
}

export default Timestamp;
